export default "images/sleep-background.svg";